export default __webpack_public_path__ + "static/Corprate_WhoWeAre_BoardofDirectors_MB_03-0eacf88826c0ef304697756025cf7405.jpg";